import { connection } from "./jsstore_con";
import { DATA_TYPE } from "jsstore";

const getDatabase = () => {
    const tblCustomerChats = {
        name: 'CustomerChats',
        columns: {
            id: {
                primaryKey: true,
                autoIncrement: false,
                dataType: DATA_TYPE.Number,
            },
            hash: {
                dataType: DATA_TYPE.String,
            },
            customer_id: {
                notNull: true,
                dataType: DATA_TYPE.Number,
            },
            type: {
                dataType: DATA_TYPE.Number
            },
            message: {
                dataType: DATA_TYPE.String,
            },
            message_header: {
                dataType: DATA_TYPE.String,
            },
            message_footer: {
                dataType: DATA_TYPE.String,
            },
            message_buttons: {
                dataType: DATA_TYPE.String,
            },
            tag_type: {
                dataType: DATA_TYPE.String,
            },
            caption: {
                dataType: DATA_TYPE.String,
            },
            document_name: {
                dataType: DATA_TYPE.String,
            },
            is_temp: {
                dataType: DATA_TYPE.Number,
            },
            ack: {
                dataType: DATA_TYPE.Number,
            },
            chat_ticket_id: {
                dataType: DATA_TYPE.Number,
            },
            is_research: {
                dataType: DATA_TYPE.Number,
            },
            instance_id: {
                dataType: DATA_TYPE.Number,
            },
            user_sending_id: {
                dataType: DATA_TYPE.Number,
            },
            user_sending_img: {
                dataType: DATA_TYPE.String,
            },
            is_log_message: {
                dataType: DATA_TYPE.Boolean,
            },
        },
        alter: {
            2: {
                add: {
                    instance_id: {
                        dataType: DATA_TYPE.Number,
                    },
                },
            },
            3: {
                modify: {
                    is_temp: {
                        dataType: DATA_TYPE.Number,
                    },
                }
            },
            6: {
                add: {
                    message_header: {
                        dataType: DATA_TYPE.String,
                    },
                    message_footer: {
                        dataType: DATA_TYPE.String,
                    },
                    message_buttons: {
                        dataType: DATA_TYPE.String,
                    },
                    caption: {
                        dataType: DATA_TYPE.String,
                    },
                },
            },
            11: {
                add: {
                    user_sending_id: {
                        dataType: DATA_TYPE.Number,
                    },
                    user_sending_img: {
                        dataType: DATA_TYPE.String,
                    }
                },
            },
            17: {
                add: {
                    is_log_message: {
                        dataType: DATA_TYPE.Boolean
                    }
                }
            }
        }
    };

    const tblChatTickets = {
        name: 'ChatTickets',
        columns: {
            id: {
                primaryKey: true,
                autoIncrement: false,
                dataType: DATA_TYPE.Number,
            },
            instance_id: {
                dataType: DATA_TYPE.Number,
            },
            protocol: {
                dataType: DATA_TYPE.String,
            },
            last_msg: {
                dataType: DATA_TYPE.String,
            },
            finished_ticket: {
                dataType: DATA_TYPE.Number
            },
            user_id: {
                dataType: DATA_TYPE.Number,
            },
            started_at: {
                dataType: DATA_TYPE.String,
            },
            finished_at: {
                dataType: DATA_TYPE.String,
            },
            is_finishing: {
                dataType: DATA_TYPE.Boolean,
            },
            is_research: {
                dataType: DATA_TYPE.Number,
            },
            isNotResponded: {
                dataType: DATA_TYPE.Boolean,
            },
            inbox: {
                dataType: DATA_TYPE.Number,
            },
            inbox_department_id: {
                dataType: DATA_TYPE.Number,
            },
            priority: {
                dataType: DATA_TYPE.Number,
            },
            pickableInboxChat: {
                dataType: DATA_TYPE.Boolean,
            },
            createdAt: {
                dataType: DATA_TYPE.String,
            },
            last_cost_created_at: {
                dataType: DATA_TYPE.String,
            },
            curretTimestamp: {
                dataType: DATA_TYPE.String,
            },
            user: {
                dataType: DATA_TYPE.Object,
            },
            instance: {
                dataType: DATA_TYPE.Object,
            },
            customer: {
                dataType: DATA_TYPE.Object
            },
            customerLastChat: {
                dataType: DATA_TYPE.Object,
            },
            customer_id: {
                dataType: DATA_TYPE.Number,
            },
            is_campaign: {
                dataType: DATA_TYPE.Number
            },
            open_by_template: {
                dataType: DATA_TYPE.Number
            },
            bot_is_active: {
                dataType: DATA_TYPE.Number
            },
            unseenMsg: {
                dataType: DATA_TYPE.Number
            }
        },
        alter: {
            4: {
                add: {
                    inbox_department_id: {
                        dataType: DATA_TYPE.Number,
                    },
                },
            },
            7: {
                add: {
                    open_by_template: {
                        dataType: DATA_TYPE.Number,
                    },
                },
            },
            8: {
                add: {
                    last_cost_created_at: {
                        dataType: DATA_TYPE.String,
                    },
                },
            },
            12: {
                add: {
                    bot_is_active: {
                        dataType: DATA_TYPE.Number
                    },
                },
            },
            14: {
                add: {
                    priority: {
                        dataType: DATA_TYPE.Number
                    },
                },
            },
            15: {
                add: {
                    is_research: {
                        dataType: DATA_TYPE.Number,
                    },
                },
            },
            16: {
                add: {
                    unseenMsg: {
                        dataType: DATA_TYPE.Number
                    }
                }
            },
            17: { 
                add: { 
                    document_register: { 
                        dataType: DATA_TYPE.String 
                    } 
                } 
            }
        }
    };
    
    const tblCustomer = {
        name: 'Customer',
        columns: {
            id: {
                primaryKey: true,
                autoIncrement: false,
                dataType: DATA_TYPE.Number,
            },
            name: {
                dataType: DATA_TYPE.String,
            },
            phone_number: {
                dataType: DATA_TYPE.String,
            },
            image: {
                dataType: DATA_TYPE.String,
            },
            is_blacklisted: {
                dataType: DATA_TYPE.Number
            },
            is_blacklisted_campaign: {
                dataType: DATA_TYPE.Number
            },
            is_favorite: {
                dataType: DATA_TYPE.Number,
            },
            document_register: {
                dataType: DATA_TYPE.String,
            },
            open_field: {
                dataType: DATA_TYPE.String,
            }
        }
    }

    const tblSettings = {
        name: 'Settings',
        columns: {
            id: {
                primaryKey: true,
                autoIncrement: false,
                dataType: DATA_TYPE.Number,
            },
            instance_id: {
                dataType: DATA_TYPE.Number,
            },
            key: {
                dataType: DATA_TYPE.String,
            },
            value: {
                dataType: DATA_TYPE.String,
            }
        }
    }

    const tblCustomerChatReactions = {
        name: 'CustomerChatReactions',
        columns: {
            id: {
                primaryKey: true,
                autoIncrement: false,
                dataType: DATA_TYPE.Number,
            },
            ack: {
                dataType: DATA_TYPE.Number,
            },
            type: {
                dataType: DATA_TYPE.Number,
            },
            sent_at: {
                dataType: DATA_TYPE.String,
            },
            reaction_text: {
                dataType: DATA_TYPE.String
            },
            customer_chat_id: {
                dataType: DATA_TYPE.Number,
            },
            customer_id: {
                dataType: DATA_TYPE.Number,
            }
        }
    };

    const tblOrderByMsg = {
        name: 'OrderByMsg',
        columns: {
            id: {
                primaryKey: true,
                autoIncrement: false,
                dataType: DATA_TYPE.Number,
            },
            name: {
                dataType: DATA_TYPE.String,
            },
            price: {
                dataType: DATA_TYPE.Number,
            },
            quantity: {
                dataType: DATA_TYPE.Number,
            },
            thumbnailId: {
                dataType: DATA_TYPE.String
            },
            thumbnailUrl: {
                dataType: DATA_TYPE.String,
            },
            currency: {
                dataType: DATA_TYPE.String,
            },
            customer_chat_id: {
                dataType: DATA_TYPE.Number
            }
        }
    };

    const tblCustomerGroup = {
        name: 'CustomerGroup',
        columns: {
            id: {
                primaryKey: true,
                autoIncrement: false,
                dataType: DATA_TYPE.Number,
            },
            group_id: {
                dataType: DATA_TYPE.Number,
            },
            customer_id: {
                dataType: DATA_TYPE.Number
            },
            name: {
                dataType: DATA_TYPE.String,
            },
            color_tag: {
                dataType: DATA_TYPE.String,
            }
        }
    };

    return {
        name: process.env.VUE_APP_APP_TITLE,
        version: 17,
        tables: [tblCustomerChats, tblChatTickets, tblCustomer, tblSettings, tblCustomerChatReactions, tblOrderByMsg, tblCustomerGroup]
    };
};

export const initJsStore = async () => {
    const dataBase = getDatabase();
    return await connection.initDb(dataBase);
};

